// filterService.ts
export interface Filtros {
  quartos?: string[];
  suites?: string[];
  banheiros?: string[];
  banheiro_servico?: string[];
  quarto_servico?: string[];
  vagas_por_unidade?: string[];

  pavimentos_min?: number;
  pavimentos_max?: number;
  elevadores_min?: number;
  elevadores_max?: number;
  torres_min?: number;
  torres_max?: number;

  unidades_ofertadas_min?: number;
  unidades_ofertadas_max?: number;
  unidades_vendidas_min?: number;
  unidades_vendidas_max?: number;
  percentual_vendido_min?: number;
  percentual_vendido_max?: number;
  unidades_estoque_min?: number;
  unidades_estoque_max?: number;
  percentual_estoque_min?: number;
  percentual_estoque_max?: number;
  vagas_empreendimento_min?: number;
  vagas_empreendimento_max?: number;

  lazer?: number[];
  infraestrutura?: number[];
  seguranca?: number[];
  incorporadora?: number[];
  estado?: string;
  municipio?: string[];
  bairro?: string[];
  segmento?: number[];
  fase_empreendimento?: string[];

  inicio_vendas_de?: string; // yyyy-mm-dd
  inicio_vendas_ate?: string;
  entrega_de?: string;
  entrega_ate?: string;
  preco_min?: number;
  preco_max?: number;
  preco_medio_min?: number;
  preco_medio_max?: number;
  vgv_min?: number;
  vgv_max?: number;
  area_min?: number;
  area_max?: number;
}

export const buildQueryParams = (filtros: Filtros) => {
  const params = new URLSearchParams();

  Object.entries(filtros).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      !(Array.isArray(value) && value.length === 0) // não adiciona arrays vazios
    ) {
      if (Array.isArray(value)) {
        params.append(key, value.join(",")); // arrays -> "1,2,3"
      } else {
        params.append(key, value.toString()); // números e strings
      }
    }
  });

  return params.toString();
};
